module.exports = __webpack_public_path__ + "img/deviceeui.0159cb26.png";